import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';

export async function save(payload) {
    return request(`/iwms-wms/wms/storertnntc`, {
        method: 'POST',
        body: payload,
    });
}

export async function modify(payload) {
    return request(`/iwms-wms/wms/storertnntc/modify`, {
        method: 'POST',
        body: payload,
    });
}

export async function editNote(payload) {
    return request(`/iwms-wms/wms/storertnntc/${payload.uuid}/modifyNote?version=${payload.version}`, {
        method: 'POST',
        body: payload.items,
    });
}

export async function getByUuid(payload) {
    return request(`/iwms-wms/wms/storertnntc?uuid=${payload}`);
}

export async function getByBillNumberAndDcUuid(payload) {
    return request(`/iwms-wms/wms/storertnntc/number?billNumber=${payload.billNumber}&dcUuid=${payload.dcUuid}`);
}


export async function query(payload) {
    return request(`/iwms-wms/wms/storertnntc/page`, {
        method: 'POST',
        body: payload,
    });
}

export async function remove(payload) {
    return request(`/iwms-wms/wms/storertnntc/remove?uuid=${payload.uuid}&version=${payload.version}`, {
        method: 'POST'
    });
}

export async function finish(payload) {
    return request(`/iwms-wms/wms/storertnntc/finish?uuid=${payload.uuid}&version=${payload.version}`, {
        method: 'POST'
    });
}

export async function abort(payload) {
    return request(`/iwms-wms/wms/storertnntc/abort?uuid=${payload.uuid}&version=${payload.version}`, {
        method: 'POST'
    });
}

export async function approve(payload) {
    return request(`/iwms-wms/wms/storertnntc/approve?uuid=${payload.uuid}&version=${payload.version}`, {
        method: 'POST'
    });
}

export async function batchImport(payload) {
    return request(`/iwms-wms/wms/storertnntc/batchimport?companyUuid=${loginCompany().uuid}&dcUuid=${loginOrg().uuid}&fileKey=${payload.fileKey}`, {
        method: 'POST'
    });
}

export async function copy(payload) {
    return request(`/iwms-wms/wms/storertnntc/copy?uuid=${payload}`, {
        method: 'POST'
    });
}

export async function saveAndApprove(payload) {
    return request(`/iwms-wms/wms/storertnntc/save/approve`, {
        method: 'POST',
        body: payload
    });
}

export async function batchRtn(payload) {
    return request(`/iwms-wms/wms/storertnntc/batch/gen?containerBarcode=${payload.containerBarcode}`, {
        method: 'POST',
        body: payload.uuids
    });
}
// export async function getImportTemplateUrl() {
//     return request(`/iwms-wms/wms/storertnntc/templet/download`);
// }

export async function queryVendors(payload) {
    return request(`/iwms-wms/wms/storertnntc/${payload.billUuid}/vendors`);
}


export async function getVendorDefaultInfo(payload) {
    return request(`/iwms-wms/wms/storertnntc/getVendorDefaultInfo?billNumber=${payload.billNumber}&dcUuid=${loginOrg().uuid}`);
}

export async function queryStocks(payload) {
    return request(`/iwms-wms/wms/vendorrtnntc/stocks`, {
        method: 'POST',
        body: payload,
    });
}
